import { formatOfficeActiveLocations } from '@/common';
import { OfficeActiveLocations } from '@/types';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { ActiveLocationValue, Section, SectionTitle } from '../styled';

type BrokerActiveLocationsProps = {
  activeLocations?: OfficeActiveLocations | null;
};

export const BrokerActiveLocations: FC<BrokerActiveLocationsProps> = ({ activeLocations }) => {
  const t = useTranslations('memberProfile');
  const politicalDistricts = formatOfficeActiveLocations(activeLocations);

  if (!politicalDistricts) return null;

  return (
    <Section>
      <SectionTitle>{t('activeLocations.politicalDistricts')}</SectionTitle>
      <ActiveLocationValue>{politicalDistricts}</ActiveLocationValue>
    </Section>
  );
};
